module.exports = __webpack_public_path__ + "img/empty.3a80dfa7c4d7aa5514315601c93eafc5.png";